import { Component, OnInit } from '@angular/core';
import { ProgressStepperComponent } from '../../shared/components/progress-stepper/progress-stepper.component';
import { NavigationButtonsComponent } from 'src/app/shared/components/navigation-buttons/navigation-buttons.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { HeaderService } from 'src/app/services/header.service';
import { StepOneComponent } from './step-one/step-one.component';
import { CommonModule } from '@angular/common';
import { StepTwoComponent } from './step-two/step-two.component';
import { StepThreeComponent } from './step-three/step-three.component';
import { StepFourComponent } from './step-four/step-four.component';

@Component({
  selector: 'app-payment-wizard',
  standalone: true,
  imports: [CommonModule, ProgressStepperComponent, NavigationButtonsComponent, TranslocoDirective, StepOneComponent, StepTwoComponent, StepThreeComponent, StepFourComponent],
  templateUrl: './payment-wizard.component.html',
  styleUrl: './payment-wizard.component.css',
})
export class PaymentWizardComponent implements OnInit {
  public steps: string[] = ['Επίλεξε καταχώριση', 'ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΗΣΗΣ', 'Τρόπος πληρωμής', 'Επισκοπηση'];
  public stepCounter: number = 1;
  public hidePrevious: boolean = true;
  public customNextTitle: string = 'next.notFinal';

  constructor(private _headerService: HeaderService) {}

  ngOnInit(): void {
    // # Convert all title steps to uppercase
    this.steps = this.steps.map((step) => step.toUpperCase());
    // # Wizard title
    this._headerService.setAltNavigation('Πληρωμή υπηρεσίας', '/home');
  }
  onNextClick() {
    if (this.stepCounter < 4) this.stepCounter++;
    this.customNextTitle = this.stepCounter === 4 ? 'next.Final' : 'next.notFinal';
    this.hidePrevious = this.stepCounter === 1;
  }
  
  onPrevClick() {
    if (this.stepCounter > 1) this.stepCounter--;
    this.customNextTitle = this.stepCounter === 4 ? 'next.Final' : 'next.notFinal';
    this.hidePrevious = this.stepCounter === 1;
  }
}
